// extracted by mini-css-extract-plugin
export var hidden = "_pc-1";
export var visible = "_pc-0";